import React from 'react';
import './SponsoredNav.css';

const Nav: React.FC = () => {
  return (
    <nav className="sponsored-nav" role="navigation" aria-label="Main">
      <div className="sponsored-nav__inner">
        <a href="/" aria-label="Succit home" className="sponsored-nav__brand">
          <img
            className="sponsored-nav__brand-img"
            src="/white-logo.png"
            alt="Succit logo"
          />
        </a>
      </div>
    </nav>
  );
};

export default Nav;
